import {
  WorkFlowCreateInterface,
  WorkflowInterface,
} from 'modules/workflows/types/workflow-interface'
import httpClient from 'shared/utils/http-client'

export const WORKFLOWS_API = '/api/dashboard/customer/workflows'

export const removeWorkflow = (id: number) => httpClient.delete(`${WORKFLOWS_API}/${id}`)

export const updateWorkflow = (id: number, data: WorkFlowCreateInterface) =>
  httpClient.put(`${WORKFLOWS_API}/${id}`, data)

export const createWorkflow = (data: WorkFlowCreateInterface) =>
  httpClient.post<WorkflowInterface>(WORKFLOWS_API, data)
